import React from "react";
import { Crown, Feather, BookHeart } from "lucide-react";

const RITUELS = [
  {
    icon: Crown,
    title: "Nom de Reine",
    text:
      "À son arrivée, chaque femme reçoit un nom symbolique — un nom qui ne porte plus la violence, mais la force et la souveraineté.",
    key: "nom-reine",
  },
  {
    icon: Feather,
    title: "Cape Symbolique",
    text:
      "Une cape lui est remise : elle signifie publiquement qu&apos;elle est souveraine de sa propre vie.",
    key: "cape",
  },
  {
    icon: BookHeart,
    title: "Carnet de Résilience",
    text:
      "Un carnet intime pour consigner, à sa main, chaque étape de sa transformation.",
    key: "carnet",
  },
];

export default function Rituel() {
  return (
    <section
      id="rituel"
      data-testid="rituel-section"
      className="relative bg-[#4A192C] text-[#FAF7F2] py-24 lg:py-36 overflow-hidden sdm-grain"
    >
      <div className="max-w-[1200px] mx-auto px-6 relative z-10">
        <div className="max-w-2xl">
          <p className="sdm-divider text-[#C5A059]">Cérémonie d&apos;entrée</p>
          <h2 className="font-serif-display text-4xl lg:text-6xl mt-8 leading-tight">
            Le Rituel de <em className="text-[#C5A059]">Renaissance</em>
          </h2>
          <p className="mt-6 text-[#FAF7F2]/80 text-lg leading-relaxed">
            Trois gestes sacrés qui transforment l&apos;arrivée en un moment
            de dignité retrouvée.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-[#C5A059]/25">
          {RITUELS.map((r, i) => (
            <div
              key={r.key}
              data-testid={`rituel-card-${r.key}`}
              className="bg-[#4A192C] p-10 lg:p-12 hover:bg-[#3A1222] transition-colors duration-500 group"
            >
              <div className="flex items-start justify-between">
                <r.icon className="w-10 h-10 text-[#C5A059] group-hover:scale-110 transition-transform duration-500" />
                <span className="font-serif-display text-2xl text-[#C5A059]/50">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-serif-display text-3xl mt-10">{r.title}</h3>
              <p
                className="mt-4 text-[#FAF7F2]/75 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: r.text }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Decorative marquee */}
      <div className="mt-24 overflow-hidden opacity-40">
        <div className="sdm-marquee-track font-serif-display italic text-5xl text-[#C5A059]">
          {Array.from({ length: 2 }).map((_, i) => (
            <React.Fragment key={i}>
              <span>Dignité</span>
              <span>·</span>
              <span>Souveraineté</span>
              <span>·</span>
              <span>Résilience</span>
              <span>·</span>
              <span>Renaissance</span>
              <span>·</span>
              <span>Reine</span>
              <span>·</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
